export default __webpack_public_path__ + "static/gallery-writing-journalism-8a3db667f91e8ba98268b40e573e7cd7.png";